import Component from '@glimmer/component';

export default class PageBuilderOptionsHeight extends Component {
  // Getter and setter
  get heightUnits() {
    return [
      { value: '%', label: '%' },
      { value: 'px', label: 'px' },
    ];
  }

  // Template
  <template>
    <@form.fieldset
      @titleKey='size'
      @isClosed={{true}}
      @showSelectedAttributesIndicator={{true}}
      as |fieldset|
    >
      <div class='o-layout'>
        <div class='o-layout__item u-1/2'>
          <fieldset.field @property='options.heightValue' />
        </div>
        <div class='o-layout__item u-1/2'>
          <fieldset.field
            @property='options.heightUnit'
            @type='select-value'
            @options={{this.heightUnits}}
          />
        </div>
      </div>
    </@form.fieldset>
  </template>
}
